// extracted by mini-css-extract-plugin
module.exports = {"table":"SitesTable_table__3HIHS","button":"SitesTable_button__2kqra"};